import Link from 'next/link';
import Image from 'next/image';
import styled, { Box, useTheme } from '@xstyled/styled-components';
import { footerItems } from 'global/data';
import { Container } from '@/UI/Layout/Container';
import { FlexBox } from '@/UI/Primitives/FlexBox';
import { SectionTitle } from '@/UI/Primitives/Headings';
import { Facebook, Instagram } from '@/UI/Icons';
import { useRouter } from 'next/router';

import { useTranslation } from 'next-i18next';

const FooterContainer = styled.footer`
  position: relative;
  padding: 1.25rem 2rem 12rem;
  background-color: #fafbfc;

  @media (min-width: desktop) {
    padding: 1.25rem 2rem 10rem;
  }

  a.trusted {
    position: absolute;
    bottom: -7rem;
    left: 0;
    width: 75px;
    height: 75px;

    @media (min-width: desktop) {
      left: initial;
      right: 26%;
      top: 75%;
      width: 100px;
      height: 100px;
    }

    &:hover {
      opacity: 0.8;
    }
  }

  a svg:hover {
    fill: teal-200;
  }

  a:hover {
    color: gray-200;
  }
`;

const LinkSection = ({ heading, start, end }) => {
  const router = useRouter();

  const theme = useTheme();
  return (
    <Box mb={32}>
      <SectionTitle fontSize={theme.fontSizes.medium}>{heading}</SectionTitle>
      <ul>
        {footerItems[`${router.locale}`].content
          .slice(start, end)
          .map((item, i) => {
            return (
              <Box as="li" lineHeight="2" key={i}>
                <Link
                  href={item.path === 'blogi' ? '/blogi' : '/info/[page]'}
                  as={item.path === 'blogi' ? '/blogi' : `/info/${item.path}`}
                >
                  <a aria-label={item.title}>{item.title}</a>
                </Link>
              </Box>
            );
          })}
      </ul>
    </Box>
  );
};

export default function Footer() {
  const { t } = useTranslation();

  return (
    <FooterContainer>
      <Container
        display={{ lg_tablet: 'flex' }}
        justifyContent="space-between"
        pt={{ _: 0, lg_tablet: 96 }}
      >
        <Box
          as="p"
          maxW={{ _: 340, lg_desktop: 400 }}
          color="gray"
          lineHeight="1.75"
          display={{ _: 'none', desktop: 'block' }}
        >
           {t('footer.footer_text')}
        </Box>
        <Box
          display={{ lg_tablet: 'grid' }}
          gridTemplateColumns="1fr 1fr"
          columnGap={64}
          mr={{ desktop: 160 }}
        >
          <LinkSection heading={t('footer.heading1')} start={0} end={4} />
          <LinkSection heading={t('footer.heading2')} start={4} end={8} />
          <Box>
            <FlexBox spaceX={16} my={8}>
              <a
                href="https://www.instagram.com/baltbaby"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Link to Baltbaby's Instagram"
              >
                {Instagram}
              </a>
              <a
                href="https://www.facebook.com/baltbaby"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Link to Baltbaby's Facebook"
              >
                {Facebook}
              </a>
            </FlexBox>
            <FlexBox dir="column" mt={16}>
          
              <a href="mailto:klienditeenindus@baltbaby.com">
                klienditeenindus@baltbaby.com
              </a>
              <a href="tel:+37256988255"> +372 5698 8255</a>
            </FlexBox>
            <a
              className="trusted"
              href="https://www.e-kaubanduseliit.ee/liidust/usaldusmargisega-e-poed-eestis"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Image
                src="/images/turvaline_ostukoht_must.png"
                alt="Label indicating the store is safe"
                layout="fill"
              />
            </a>
          </Box>
        </Box>
      </Container>
    </FooterContainer>
  );
}
